export default __webpack_public_path__ + "static/media/030_corner1_02.3de1f756.mp3";